import { svg } from "config/svgStyles";

export const cardButton =
  ({ backgroundColor, color }) =>
  () => ({
    backgroundColor,
    color,
    margin: "0",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
    fontFamily: "body",
    width: "100%",
    flexGrow: 1,
    flexShrink: 1,

    "&:focus": {
      outline: `solid 2px ${backgroundColor}`,
      outlineOffset: "2px",
    },

    transition: "all 0.25s ease",

    "&:hover": {
      transform: "translateX(0.5em)",
    },
    position: "relative",
  });

export const cornerTag = {
  padding: "5px 15px 5px 10px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  position: "absolute",
  right: 0,
  backgroundColor: "black",
  color: "white",
  border: "1px solid white",
  borderWidth: "0 0 1px 1px",
  borderRadius: "0 20px 0 10px",
};

export const cornerTagText = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "12px",
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

export const cornerTagImg = {
  width: "76px",
};

export const backgroundWrapper = ({ backgroundImage }) => ({
  backgroundImage: `url(${backgroundImage})`,
  width: "100%",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  borderRadius: "20px",
});

export const labelBox = ({ isMobile }) => ({
  padding: "30px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  flexGrow: 1,
  flexShrink: 1,
  width: "100%",
  minHeight: isMobile ? "124px" : "170px",
});

export const logoContainer =
  ({ nLogos }) =>
  ({ isMobile }) => ({
    maxWidth: nLogos === 1 ? "50%" : isMobile ? "80%" : "50%",

    display: "flex",
    gap: "10px",
    alignItems: "center",
  });

export const logo = ({ nLogos, widthOverride }) => ({
  width: widthOverride || nLogos === 1 ? "80%" : "auto",
  marginRight: "auto",
  cursor: "pointer",
});

export const description = {
  marginBottom: "10px",
  lineHeight: "1",
};

export const selectLabel = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "7px 15px 7px 25px",
  gap: "10px",
  height: "30px",
  background: "#000000",
  borderRadius: "15px",
  marginTop: "20px",
  border: "solid 1px",
  boxSizing: "border-box",
  cursor: "pointer",
  fontFamily: "body",
  fontWeight: "light",
  lineHeight: "1",
  textTransform: "uppercase",
  textDecoration: "none",
  whiteSpace: "nowrap",
  borderColor: "black",
  color: "white",

  svg: {
    ...svg("white"),
  },
};

export const subText = {
  marginTop: "10px",
  textAlign: "left",
};
